import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageContent } from '../page-content';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    standalone: false
})
export class FAQComponent implements OnInit {

  languageList = require('../page-content').languageList;
  content = require("../page-content").content;

  constructor(private router:Router) { }

  ngOnInit(): void {


  }

  languageClick(code: string) {
    PageContent.selectedLanguageCode = code;
  }

  getSelectedLanguagesCode(): string {
    return PageContent.selectedLanguageCode;
  }

  onBacktoMainPage() {
    localStorage.clear();
    this.router.navigate(["/auth/sign-in"]);
  }

}
